module.exports = __webpack_public_path__ + "static/media/shopping-bag.52aa0ab1.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/common/icon/shopping-bag.png
// module id = 680
// module chunks = 0